import wrapWithProvider from "./wrap-with-provider";
import { adsense } from "./src/utils/adsense";
import {
  clearScenarioMenuReturnPath,
  isScenarioMenuPath,
  isScenarioPagePath,
} from "./src/utils/scenario-menu-navigation";

let previousPath: string | null = null;

export const onClientEntry = () => {
  adsense.loadScript();
};

export const onRouteUpdate = ({ location }: { location: Location }) => {
  adsense.loadScript();

  const currentPath = location.pathname;

  if (isScenarioPagePath(currentPath)) {
    if (!previousPath || !isScenarioMenuPath(previousPath)) {
      clearScenarioMenuReturnPath();
    }
  }

  previousPath = currentPath;
};

export const wrapRootElement = wrapWithProvider;
